"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultBodytype = exports.getDefaultMotorization = exports.singleClassSelectorFirstStep = void 0;
exports.vehicleDivision = vehicleDivision;
exports.formatFuelType = formatFuelType;
exports.getMainFuelType = getMainFuelType;
exports.capitalize = capitalize;
exports.getDefaultImage = getDefaultImage;
const types_1 = require("@/store/modules/vmds/types");
const constants_1 = require("@/store/modules/vehicleSelector/constants");
exports.singleClassSelectorFirstStep = constants_1.STEPS.THREE_CHOOSE_MOTORIZATION;
function vehicleDivision(productGroup) {
    switch (productGroup) {
        case types_1.ProductGroup.VAN:
            return 'van';
        case types_1.ProductGroup.PASSENGER_CAR:
            return 'car';
        default:
            return '';
    }
}
function formatFuelType(fuelType = '') {
    return fuelType.replace('_', ' ').toLowerCase();
}
function getMainFuelType(fuelTypes) {
    return fuelTypes.length ? fuelTypes[0] : '';
}
function capitalize(value) {
    return typeof value === 'string' ? `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}` : '';
}
function getDefaultImage(vehicle) {
    return vehicle.stagedImgURL;
}
const getDefaultMotorization = (vehicles, typeId) => {
    return vehicles.find((item) => item.typeId === typeId) || vehicles[0];
};
exports.getDefaultMotorization = getDefaultMotorization;
const getDefaultBodytype = (vehicleClass, bodytypeId) => {
    const bodytypes = vehicleClass.bodies;
    const defaultBodytype = bodytypes.find((item) => {
        return item.id === bodytypeId;
    });
    return defaultBodytype || bodytypes[0];
};
exports.getDefaultBodytype = getDefaultBodytype;
